<template>
  <page-content>
    <div class="col-middle">
      <div class="text-center text-center">
        <h1 class="error-number">404</h1>
        <h2>Xin lỗi nhưng chúng tôi không thể tìm thấy trang này</h2>
        <p>Trang bạn đang tìm kiếm này tồn tại <a href="#">Báo cáo?</a>
        </p>
        <div class="mid_center">
          <h3>
            <router-link to="/">Trở về trang chủ</router-link>
          </h3>
        </div>
      </div>
    </div>
  </page-content>
</template>

<script>
export default {
  name: "404Error"
}
</script>

<style scoped>

</style>